(function(){
  function ready(fn){
    if(document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  ready(function(){
    document.documentElement.classList.add('pg-farma-enhanced');
    var labels = {
      'integratori': '+',
      'farmaci': 'RX',
      'farmaci da banco': 'RX',
      'cosmetica': 'DERM',
      'igiene': 'SAFE',
      'veterinaria': 'PET',
      'rimedi per': '?',
      'offerte': '%'
    };
    document.querySelectorAll('.header-04 .header__menu-vertical .menu-lv-1__action').forEach(function(link){
      var text = (link.textContent || '').trim().toLowerCase();
      if(link.querySelector('.pg-menu-badge')) return;
      var icon = '+';
      Object.keys(labels).some(function(key){ if(text.indexOf(key) !== -1){ icon = labels[key]; return true; } return false; });
      var badge = document.createElement('span');
      badge.className = 'pg-menu-badge';
      badge.textContent = icon;
      badge.setAttribute('aria-hidden','true');
      link.insertBefore(badge, link.firstChild);
    });
  });
})();

(function(){
  function ready(fn){ if(document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function(){
    document.querySelectorAll('.template-product .productView-nav:not(.slick-initialized), .template-product .productView-for:not(.slick-initialized)').forEach(function(gallery){
      var slides = Array.prototype.slice.call(gallery.children || []);
      if(slides.length > 1){
        gallery.classList.add('pg-horizontal-product-gallery');
        slides.forEach(function(slide){ slide.classList.add('pg-horizontal-product-slide'); });
      }
    });
  });
})();
